export enum ConnectionType {
  Syndicate,
  FTP,
  SFTP
}